class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.closeButton = this.querySelector("[data-search-close]");
    this.megaMenuOpener = this.querySelector("mega-menu-opener");
  }

  connectedCallback() {
    this.addEventListener("menu:open", (e) => {
      if (!e.detail) return;
      if (e.detail.context === "header-search") {
        setTimeout(() => {
          this.input.focus();
          this.input.setSelectionRange(
            this.input.value.length,
            this.input.value.length,
          );

          document.activeElement;
        }, 500);
      }
    });

    if (this.closeButton) {
      this.closeButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.input?.blur();

        if (this.megaMenuOpener && typeof this.megaMenuOpener._close === "function") {
          this.megaMenuOpener._close();
          this.megaMenuOpener.querySelector("summary")?.focus();
          return;
        }

        const details = this.querySelector("details");
        if (details) {
          details.classList.remove("open");
          details.open = false;
        }
      });
    }

    document.addEventListener("menu:close", (e) => {
      if (!e.detail) return;
      if (e.detail.context === "header-search") {
        this.input.blur();
      }
    });

    this.input.addEventListener("input", () => {
      if (this.input.value) {
        const totalCharacters = this.input.value.length;
        this.input.style.width = `${totalCharacters + 2}ch`;
      } else {
        this.input.style.width = `180px`;
      }
    });
  }
}

if (!customElements.get("header-search")) {
  customElements.define("header-search", HeaderSearch);
}
